import { isInViewport } from "./utils";

/*
PDP mix ratios
*/
const ratioChart = document.querySelector('#product-mix-ratios .mix-ratios-chart');
if (ratioChart) {
    let rendered = false;
    $(window).scroll(function () {
        if (rendered) {
            return;
        }
        if (isInViewport(ratioChart)) {
            new Chart(ratioChart, {
                type: 'pie',
                data: window.chartData[ratioChart.dataset.productId],
                options: {
                    legend: {
                        display: false
                    }
                }
            });
            rendered = true;
        }
    });
}

/*
Product category in dealer mode
*/
const productRowDetails = document.querySelectorAll('.product-row-details');
productRowDetails?.forEach(detailsEl => {
    const ratioChart = detailsEl.querySelector('.mix-ratios-chart');
    if (ratioChart) {
        let rendered = false;
        detailsEl.addEventListener("toggle", (event) => {
            if (detailsEl.open) {
                if (!rendered) {
                    new Chart(ratioChart, {
                        type: 'pie',
                        data: window.chartData[ratioChart.dataset.productId],
                        options: {
                            legend: {
                                display: false
                            }
                        }
                    });
                    rendered = true;
                }
            }
        });
    }
});


/*
Videos
*/
$('.video-trigger').on('click', function (e) {
    e.preventDefault();
    $('#player-container').html(embeds[$(this).data('embed')]);
    youtubeIframeAssistant();
    let iframe = $('#player-container').find('iframe');
    iframe[0].src += "&autoplay=1";
    $('#video-player').addClass('shown');
});

/*
Product guide section
*/
$('#product-guide-switcher .guide-label').on('click', function (e) {
    e.preventDefault();
    $('.guide-label, .guide-content').removeClass('active');
    $(this).addClass('active');
    $($(this).data('target')).trigger('click');
    $('#active-tab-label').text($(this).text());
    $('.dropdown').removeClass('is-open');
});

$('.guide-content table').wrap('<div class="scrolling-table"/>');


class ProductForm {
    constructor(el) {
        this.form = el.querySelector('.cart');
        this.quantity = el.querySelector('.quantity-input__field');
        this.price = this.form.dataset.price;
        this.currencySymbol = this.form.dataset.currencySymbol;
        this.currencyDecimals = this.form.dataset.currencyDecimals;
        this.total = el.querySelector('.total');
        this.increaseQuantityButton = el.querySelector('.quantity-input__adjust.up');
        this.decreaseQuantityButton = el.querySelector('.quantity-input__adjust.down');
        this.attributes = el.querySelectorAll('.attribute');
        this.attributeInputs = el.querySelectorAll('.attribute-input');
        this.options = el.querySelectorAll('.attribute-option input');
        this.addToCartButton = el.querySelector('.add-to-cart');
        this.haveDefaultOption = false;
        this.variants = null;
        this.stockMessage = el.querySelector('.stock-message');
        this.variationInput = el.querySelector('.variation_id');
        this.successMessage = el.querySelector('.atc-message');

        this.options?.forEach(option => {
            option.addEventListener('change', this.onSelectOption.bind(this));
        });
        this.form.addEventListener('show_variation', this.onShowVariation.bind(this));
        this.addToCartButton.addEventListener('click', this.onSubmit.bind(this));
        this.quantity.addEventListener('blur', this.updateTotals.bind(this));
        this.increaseQuantityButton.addEventListener('click', this.increaseQuantity.bind(this));
        this.decreaseQuantityButton.addEventListener('click', this.decreaseQuantity.bind(this));

        if (this.options.length) {
            this.variants = JSON.parse(this.form.dataset.productVariations);
            this.selectDefaultOption();
            this.validateOptions(0);
            this.onVariationUpdate();
        }
        this.updateTotals();
    }

    updateTotals() {
        if (!this.quantity.value) return;
        this.total.textContent = this.currencySymbol + parseFloat(this.price * this.quantity.value).toFixed(this.currencyDecimals).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    increaseQuantity() {
        this.quantity.stepUp();
        this.updateTotals();
    }

    decreaseQuantity() {
        this.quantity.stepDown();
        this.updateTotals();
    }

    validateOptions(groupIndex) {
        // if this option come from the last group, we have a completed set
        if (groupIndex === this.attributes.length - 1) {
            // console.log('do nothing');
            return;
        }

        // if this option is not in the last group, re-assess downstream groups
        let selectedValues = [];
        let realCombinations = [];
        this.variants.forEach(variant => {
            realCombinations.push(Object.values(variant.attributes).join(','));
        });
        this.attributes.forEach((attribute, index) => {
            const options = attribute.querySelectorAll('.attribute-option');
            if (index <= groupIndex) {
                options?.forEach(option => {
                    const inputs = option.querySelectorAll('input');
                    inputs.forEach(input => {
                        if (input.checked) {
                            selectedValues.push(input.value);
                        }
                    });
                });
            } else {
                options?.forEach(option => {
                    option.classList.remove('disabled');
                    const inputs = option.querySelectorAll('input');
                    inputs.forEach(input => {
                        input.disabled = false;
                        let proposedCombination = selectedValues.concat([input.value]).join(',');
                        if (!realCombinations.includes(proposedCombination)) {
                            option.classList.add('disabled');
                            input.disabled = true;
                            input.checked = false;
                        }
                    });
                });
            }
        });
    }

    onVariationUpdate() {
        let selectedAttributes = {};
        let foundVariant = false;

        this.hideStockMessage();

        this.attributeInputs.forEach(input => {
            selectedAttributes[input.name] = input.value;
        });

        this.variants.forEach(variation => {
            // find a matching variant
            if (this.shallowEqual(variation.attributes, selectedAttributes)) {
                let v = variation;
                let showMessage = false;
                this.price = v.display_price;
                if (v.is_in_stock && v.is_purchasable) {
                    this.variationInput.value = v.variation_id;
                    this.addToCartButton.disabled = false;
                    // user can purchase, but there could still be a message to show
                    // the message exists when the backorders = allow, but notify customer
                    // it's empty if backorders = allow or the product is in stock
                    showMessage = v.availability_html !== '';
                } else {
                    // out of stock
                    this.addToCartButton.disabled = true;
                    showMessage = true;
                }
                if (showMessage) {
                    this.stockMessage.innerHTML = v.availability_html;
                    if (v.backorders_allowed && v.backorder_message !== '') {
                        this.stockMessage.innerHTML += ' ' + v.backorder_message;
                    }
                    this.showStockMessage();
                }
                this.updateTotals();
                foundVariant = true;
                return;
            }
        });

        // totally out of stock products won't find a variant that matches attributes
        if (!foundVariant) {
            this.showStockMessage();
        }
    }

    hideStockMessage() {
        this.stockMessage.classList.add('hidden');
    }

    showStockMessage() {
        this.stockMessage.classList.remove('hidden');
    }

    // Product Add-ons might add required fields
    hasInvalidFields() {
        const addOnsContainer = this.form.querySelector('.wc-pao-addons-container');
        if (!addOnsContainer) {
            return false;
        }
        // Array.some() returns true if any field fails checkValidity();
        const addOnFields = addOnsContainer.querySelectorAll('.wc-pao-addon-field');
        return Array.from(addOnFields).some(field => !field.checkValidity());
    }

    onSubmit(e) {
        e.preventDefault();
        if (this.hasInvalidFields()) {
            return;
        }
        this.addToCartButton.classList.add('working');
        this.addToCartButton.textContent = "Adding...";
        const formData = new FormData(this.form);
        const self = this;

        // sending these values individually because sending the whole form object triggers another add to cart... somewhere
        $.ajax({
            method: 'post',
            url: window.ajaxUrl,
            data: {
                "action": "millborn_add_to_cart",
                "product_id": formData.get('product_id'),
                "variation_id": formData.get('variation_id'),
                "quantity": formData.get('quantity'),
                "source": formData.get('source'),
            },
            success: function (data) {
                $('body').trigger('updated_cart_totals');
                self.addToCartButton.classList.remove('working');
                self.addToCartButton.textContent = "Add to cart";
                self.successMessage.classList.add('shown');
                setTimeout(() => {
                    self.successMessage.classList.remove('shown');
                }, 2500);
            }
        });
    }

    onShowVariation() {
        this.onVariationUpdate();
    }

    onSelectOption(e) {
        const select = this.form.querySelector('[name="' + e.target.name + '"]')
        select.value = e.target.value;
        this.validateOptions(Number(e.target.closest('.attribute').dataset.index));
        this.onVariationUpdate();
    }

    selectDefaultOption() {
        // bail if we already have an option checked
        this.options.forEach(option => {
            if (option.checked) {
                return;
            }
        });
        const inStockVariant = this.variants.find(variant => {
            return variant.is_in_stock && variant.is_purchasable;
        });
        if (inStockVariant) {
            const keys = Object.keys(inStockVariant.attributes);
            const input = this.form.querySelector(`[name="${keys[0]}"][value="${inStockVariant.attributes[keys[0]]}"]`);
            const select = this.form.querySelector(`select[name="${keys[0]}"]`);
            input.checked = true;
            select.value = inStockVariant.attributes[keys[0]];

            // $(`select[name="${keys[0]}"]`).val(inStockVariant.attributes[keys[0]]).trigger('change');
        }
    }

    shallowEqual(object1, object2) {
        const keys1 = Object.keys(object1);
        const keys2 = Object.keys(object2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        for (let key of keys1) {
            if (object1[key] !== object2[key]) {
                return false;
            }
        }

        return true;
    }
}
const addProductPanels = document.querySelectorAll('.add-product-panel');
const singleProductForm = document.getElementById('product-form');
addProductPanels?.forEach(el => {
    new ProductForm(el);
});
if (singleProductForm) {
    new ProductForm(singleProductForm);
}

/*
Add to cart

// var totesMin = 500;
// var totesClass = 'is-totes';
var $qtyRow = $('#add-to-cart-quantity-row');
var $qtyField = $qtyRow.find('.qty');
// var $totesDisclaimer = $('#add-to-cart-totes-disclaimer');
var $priceDetails = $('#price-details');
var $itemTotal = $('.item-summary .total');
var $btn = $('#add-to-cart');
var $oosMsg = $('#oos-message');
var unitOfMeasurement = $('.product-summary .price .uom').text();
var unitOfMeasurementPlural = unitOfMeasurement ? unitOfMeasurement + 's' : '';
*/

const seedCalculators = document.querySelectorAll('.seed-calculator');
seedCalculators?.forEach(calculator => {
    const plantingInputs = calculator.querySelectorAll('[name="planting-type"]');
    const acreageInput = calculator.querySelector('[name="acreage"]');
    const submit = calculator.querySelector('.seed-calculator__submit');
    const total = calculator.querySelector('.seed-calculator__total');
    const result = calculator.previousElementSibling;
    let submitted = false;

    function calculateTotal(e) {
        e.preventDefault();
        const rateInput = calculator.querySelector('[name="planting-type"]:checked');
        const rate = parseFloat(rateInput.value);
        const acreage = parseFloat(acreageInput.value);
        submitted = true;
        if (!isNaN(rate) && !isNaN(acreage)) {
            const totalSeeds = rate * acreage;
            total.textContent = `You will need approximately ${totalSeeds.toLocaleString()} pounds.`;
            result.textContent = `You need at least ${totalSeeds.toLocaleString()} pounds.`;
        } else {
            total.textContent = 'Enter the number of acres.';
            result.textContent = '';
        }
    }

    function resetResult() {
        if (submitted) {
            submit.textContent = 'Recalculate';
        }
    };

    acreageInput.addEventListener('change', resetResult);
    plantingInputs.forEach(input => {
        input.addEventListener('change', resetResult);
    });
    submit.addEventListener('click', calculateTotal);
});
